import { z } from 'zod'

export const FiltersHelpKeys = z.enum([
  'quick_ship',
  'laser_cut_aluminum',
  'laser_cut_steel',
  'cast_aluminum',
  'cast_iron',
  'punched_steel',
  'toe_kick',
  'grille',
  'filter',
  'baseboard_vent',
  'high_velocity_outlet',
  'register'
])

export type FiltersHelpKeys = z.infer<typeof FiltersHelpKeys>